import { Button, Grid, MenuItem, Select, TextField, useTheme } from "@mui/material";
import { CoreFilterCommand } from "generated/CoreApi_v1";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IAdvFilterPickerProps, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";

////////////////////////////////////////////////////////////////////////////////

type RangeOptions = "min" | "max";


////////////////////////////////////////////////////////////////////////////////

export const RangePicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;

    const { t } = useTranslation("knowledge");
    const theme = useTheme();

    const [rangeOption, setRangeOption] = useState<RangeOptions>("min");
    const [value, setValue] = useState<number>();

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleChange = (item: RangeOptions) => {
        setRangeOption(item);
    };

    ///
    const getDisplayFilterText = (): string => {
        let name = "";

        if (filter.command == CoreFilterCommand.KnowledgeViewsCount)
            name = t("Feed.AdvancedFilter.Commands.ViewsCount");
        else if (filter.command == CoreFilterCommand.KnowledgeLikesCount)
            name = t("Feed.AdvancedFilter.Commands.LikesCount");
        else if (filter.command == CoreFilterCommand.KnowledgeCommentsCount)
            name = t("Feed.AdvancedFilter.Commands.CommentsCount");

        if (rangeOption == "min") name = `${name.replace("...", "")}: ${t("shared:Filter.Minimum")} ${value}`;
        else name = `${name.replace("...", "")}: ${t("shared:Filter.Maximum")} ${value}`;

        return name;

    };

    ///
    const handleApply = () => {
        let result = {
            command: filter.command,
            text: getDisplayFilterText(),
            range: rangeOption == "min" ? { minValue: value, maxValue: null } : { maxValue: value, minValue: null }
        } as IAdvFilterResult;

        onApply(result, filter);
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container spacing={2}>
            <Grid size={{ lg: 2, xl: 1 }}>
                <Select
                    value={rangeOption}
                    fullWidth
                    onChange={e => handleChange(e.target.value as RangeOptions)}
                    sx={{
                        svg: { color: theme.palette["warning"].main },
                        '& .MuiInputBase-input': {
                            color: theme.palette["warning"].main,
                        },
                        '&:before': {
                            borderColor: theme.palette["warning"].main,
                        }
                    }}

                >
                    <MenuItem value="min">{t("shared:Filter.Minimum")}</MenuItem>
                    <MenuItem value="max">{t("shared:Filter.Maximum")}</MenuItem>
                </Select>
            </Grid>
            <Grid size={{ xl: 2 }}>
                <TextField
                    fullWidth
                    color="warning"
                    value={value}
                    placeholder="Digite a quantidade"
                    onChange={e => setValue(parseInt(e.target.value))}
                    sx={{
                        '& .MuiInput-underline:before': { borderBottomColor: theme.palette["warning"].main },
                        input: {
                            '&::placeholder': {
                                color: theme.palette["warning"].main,
                                opacity: 1,
                            },
                        }
                    }}
                    type="number"
                    onKeyDown={(e) => { if (e.keyCode == 13 && value) handleApply(); }}
                />
            </Grid>
            <Grid>
                <Button
                    variant="text"
                    title={t("Feed.AdvancedFilter.ApplyButtonTitle")}
                    color="highlight"
                    disabled={!value}
                    onClick={handleApply}
                >
                    {t("Feed.AdvancedFilter.ApplyButtonText")}
                </Button>
                <Button
                    variant="text"
                    color="highlight"
                    title={t("Feed.AdvancedFilter.CancelButtonTitle")}
                    onClick={onCancel}
                >
                    {t("Feed.AdvancedFilter.CancelButtonText")}
                </Button>
            </Grid>
        </Grid >
    );
};
